<template>
  <form
    v-if="!loading"
    @submit.prevent="onSubmit()"
    class="card-shipping-fee-form"
  >
    <div class="row">
      <div class="col-2">
        <app-input v-model="fee.state.name" label="Estado:" disabled>
        </app-input>
      </div>
      <div class="col-2">
        <app-input
          v-model="fee.value"
          v-money="moneyConfig"
          :errors="errors.value"
          label="Valor da taxa: "
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button type="submit" :disabled="saving" v-app-button>Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import CardShippingFeesService from '@/services/card-shipping-fee.service';
import { required } from 'vuelidate/src/validators';
import NumberMixin from '@/mixins/NumberMixin';

export default {
  name: 'card-shipping-fee-form',
  mixins: [NumberMixin],
  props: ['id', 'errors', 'saving'],
  data: () => {
    return {
      loading: true,
      fee: {
        uf: null,
        value: null,
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        prefix: 'R$ ',
      },
    };
  },
  validations: {
    fee: {
      value: { required },
    },
  },
  methods: {
    loadFee(id) {
      CardShippingFeesService.getId(id)
        .then(({ data: fee }) => {
          this.fee = {
            ...fee,
            value: fee.value.toFixed(2),
          };
        })
        .catch(() => this.toastify('Erro ao carregar taxa.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.fee,
        value: this.parseDecimalInput(this.fee.value),
      });
    },
  },
  beforeMount() {
    if (this.id) this.loadFee(this.id);
  },
};
</script>

<style lang="scss" scoped>
.card-shipping-fee-form {
  label {
    color: #363636;
    text-transform: uppercase;
    font-size: 0.9em;
    font-weight: bold;
  }
}
</style>
